import React, { Component } from 'react';
import PropTypes from 'prop-types';
import css from './CwTextArea.scss';
import cx from 'classnames';

export default class CwTextArea extends Component {
  handleChange = (e) => {
    if (!this.props.onChange) {
      return;
    }
    this.props.onChange(e.target.value);
  };

  handleKeyPress = (e) => {
    if (this.props.isDisabled || !this.props.onKeyPress) {
      return;
    }
    this.props.onKeyPress(e);
  };

  focus() {
    this.textarea.focus();
  }

  render() {

    const styles = {
      wrap: {
        height: this.props.height,
        minHeight: this.props.minHeight,
        maxHeight: this.props.maxHeight,
        width: this.props.width,
        ...this.props.style
      }
    };

    return (
      <textarea
        data-cwid={this.props.cwId}
        data-cwdata={"focusable"}
        style={styles.wrap}
        className={cx(this.props.className, this.props.invalid ? css.textAreaInvalid : css.textArea)}
        placeholder={this.props.placeholder}
        readOnly={this.props.readOnly}
        value={this.props.value ? this.props.value : ''}
        onChange={this.handleChange}
        onKeyDown={this.props.onKeyDown}
        onClick={this.props.onClick}
        onKeyUp={this.props.onKeyUp}
        onKeyPress={this.handleKeyPress}
        tabIndex={this.props.disabled ? -1 : this.props.tabIndex}
        disabled={this.props.disabled}
        maxLength={this.props.maxLength}
        ref={(input) => this.textarea = input}
        autoFocus={this.props.autoFocus}
        onFocus={this.props.onFocus}
        onBlur={this.props.onBlur}
      />
    );
  }
}

CwTextArea.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: PropTypes.string,
  /**
   * Text in textfield
   */
  value: PropTypes.string,
  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: PropTypes.string,
  /**
   * Used to set text area to a read only mode
   */
  readOnly: PropTypes.bool,
  /**
   * Callback function that is fired when textarea's text changes
   */
  onChange: PropTypes.func,
  /**
   * Callback function that is fired when key is pressed while textarea is active
   */
  onKeyPress: PropTypes.func,
  /**
   * Height for textarea
   */
  height: PropTypes.number,
  /**
   * Min Height for textarea
   */
  minHeight: PropTypes.number,
  /**
   * Max Height for textarea
   */
  maxHeight: PropTypes.number,
  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: PropTypes.number,
  /**
   * Width for textarea
   */
  width: PropTypes.number,
  /**
   * Used to control order when tabbing through items
   */
  tabIndex: PropTypes.number,
  /**
   * Used to control if text is valid
   */
  invalid: PropTypes.bool,
  /**
   * Used to disable textarea
   */
  disabled: PropTypes.bool,
  /**
   * Used to control if textarea is autofocused when the page loads
   */
  autoFocus: PropTypes.bool,
  /**
   * Callback function that is fired when the component is focused
   */
  onFocus: PropTypes.func,
  /**
   * Callback function that is fired when the component is blurred
   */
  onBlur: PropTypes.func,
  /**
   * Override the styles of the root element
   */
  style: PropTypes.object,
  /**
   * The css class name to be appended to default classname
   */
  className: PropTypes.string,
};

CwTextArea.defaultProps = {
  tabIndex: 0,
};


// WEBPACK FOOTER //
// ./src/components/cwtextarea/CwTextArea.jsx